module.exports = __webpack_public_path__ + "img/joininput.043528e5.svg";